import { loginUrl } from "@/utils/constant";
import store from "@/store";
import { Toast } from "@51job/vant";
import sensors from "sa-sdk-javascript";
import wx from "weixin-js-sdk";
import Jsonp from "jsonp";
import user from "../apis/user";
import router from '@/router';
// 生成uuid
const getuuid = () => {
  if (store.state.commonStore.uuid) {
    return store.state.commonStore.uuid;
  }
  let timestamp = new Date().getTime().toString();
  let uuid =
    timestamp +
    parseInt(Math.random().toString().slice(0, 9) * 10000000).toString();
  store.commit("setValue", {
    uuid: uuid,
  });
  return uuid;
};

// 返回： 如果是首页有配置则推到配置页面，无配置则退出当前页面；不是首页有配置则返回配置页面，无配置则返回上一页
const goBack = (url) => {
  if (window.sessionStorage.firstUrl === window.location.href) {//判断是否是首页,是首页退出当前页面
    if (url) {//如果有配置页面返回配置页面
      if(store.state.commonStore.device == "harmonyApp"){//兼容鸿蒙机型
        if(url.startsWith('qiancheng') || url.startsWith('yingjiesheng') || url.startsWith('ehire')){ //原生链接
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: url
          }));
        }else{//普通链接
          window.location.href = url;
        }
      }else{//其他机型
        window.location.href = url;
      }
    }else{//没有配置项则退出当前页面
      if (store.state.commonStore.platform == "51jobApp") {//51app 退出当前页
        if(store.state.commonStore.device == "harmonyApp"){//兼容鸿蒙机型
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "qiancheng://home/exit_current_page"
          }));
        }else{
          window.location.href = "qiancheng://home/exit_current_page";
        }
      } else if (store.state.commonStore.platform == "yjsApp") {//应届生app 退出当前页
        if(store.state.commonStore.device == "harmonyApp"){//兼容鸿蒙机型
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "yingjiesheng://home/exitCurrentPage"
          }));
        }else{
          window.location.href = "yingjiesheng://home/exitCurrentPage";
        }
      }
    }
  } else {//不是首页
    if (url) {//如果有配置页面返回配置页面
      if(store.state.commonStore.device == "harmonyApp"){//兼容鸿蒙机型
        if(url.startsWith('qiancheng') || url.startsWith('yingjiesheng') || url.startsWith('ehire')){ //原生链接
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: url
          }));
        }else{//普通链接
          window.location.href = url;
        }
      }else{//其他机型
        window.location.href = url;
      }
    } else {//没有配置页面则返回上一页
      router.go(-1);
    }
  }
};
//获取今天日期
function getToday() {
  const now = new Date();
  let month = String(now.getMonth() + 1);
  month = month.length === 1 ? '0' + month : month;
  let day = String(now.getDate());
  day = day.length === 1 ? '0' + day : day;

  return now.getFullYear() + month + day;
}
//挽留关注弹窗，控制一天出现一次callBack:回调函数；showFollow：关注按钮显示条件是否满足；goodsId：活动id,typeDialog:弹窗类型
const adrBackNotice = async(callBack, showFollow,goodsId,typeDialog) => {
  const today = getToday();
  const accountid = store.state.commonStore.accountId || '';
  const key = goodsId + '_' + accountid + '_' + today + '_' + typeDialog;
  let val = localStorage.getItem(key) || '';
  console.log('yyy挽留关注是否第一次',!val);
  console.log('yyy是否已关注',showFollow);
  
  if (!val && showFollow) {
    localStorage.setItem(key, true);
    callBack(true,typeDialog)
  } else {
    callBack(false);
  }
};
// 跳转首页
const goHome = (url) => {
  const platform = store.getters.platform;
  console.log(platform, "platform");
  if (platform.indexOf("yjs") > -1) {
    //yjs
    if (platform === "yjsApp") {
      if (url) {
        window.location.href = url;
      } else {
        window.location.href = "yingjiesheng://home/openHomePage";
      }
    } else if (platform === "yjsWX") {
      wx.miniProgram.switchTab({
        url: "/pages/job/index",
      });
    } else if (platform === "yjsM") {
      window.location.href = "https://m.yingjiesheng.com";
    } else {
      window.location.href = "https://www.yingjiesheng.com";
    }
  } else {
    //51
    if (platform === "51jobApp") {
      if (url) {
        window.location.href = url;
      } else if (store.state.commonStore.device == "harmonyApp") {
        window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
          url: "qiancheng://home/exit_current_page"
        }));
      } else {
        window.location.href = "qiancheng://home/show_home_page";
      }
    } else if (platform === "51jobWX") {
      wx.miniProgram.switchTab({
        url: "/pages/index/index",
      });
    } else if (platform === "51jobM") {
      window.location.href = "https://m.51job.com";
    } else {
      window.location.href = "https://www.51job.com";
    }
  }
};

// 获取app状态栏高度
const getAppStateHeight = (height = 0) => {
  let sh = 0;
  let u = navigator.userAgent;
  let device = "";
  if (
    u.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
      if (u.indexOf("51jobapp") > -1 || u.search("51jobapp") > -1) {
        device = "androidApp";
      } else if (
        u.indexOf("yjsandroid-android-client") > -1 ||
        u.search("yjsandroid-android-client") > -1
      ) {
        device = "androidApp";
      }
    } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      if (u.indexOf("51jobapp") > -1 || u.search("51jobapp") > -1) {
        device = "iosApp";
      } else if (
        u.indexOf("yjsiphone-iphone-client") > -1 ||
        u.search("yjsiphone-iphone-client") > -1
      ) {
        device = "iosApp";
      }
    }
  }

  if (store.state.device == "androidApp" || device == "androidApp") {
    sh =
      window.android.statusBarHeight() / window.devicePixelRatio
        ? window.android.statusBarHeight() / window.devicePixelRatio
        : 0;
  }
  if (store.state.device == "iosApp" || device == "iosApp") {
    let u = navigator.userAgent;
    // let u = 'Mozilla/5.0 (iPhone; CPU iPhone OS 15_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 xy_app_iphone/1.1.0 statusBarHeight:20 navBarHeight:64 width:320 height:1023'
    let arr = u.split("statusBarHeight:");
    if (arr.length > 1) {
      sh = arr[1].split(" ")[0];
    }
  }
  if (store.getters.device == "harmonyApp") {
    sh = window.harmony.statusBarHeight() / window.devicePixelRatio ? window.harmony.statusBarHeight() / window.devicePixelRatio : 0;
  }
  sh = Math.ceil(sh);
  let stateHeight = sh + height + "px";
  return stateHeight;
};

// 判断设备环境、app类型、设备平台等
const initDevice = (from) => {
  let u = navigator.userAgent,
    device = "",
    appType = "",
    fromdomain = "",
    platform = "";

  // 设置device、appType
  if (
    u.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    if (u.toLowerCase().match(/miniProgram/i) == "miniprogram") {
      device = "wechat";
      appType = "weixin";
    } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
      // 判断是APP还是浏览器
      if (u.indexOf("xy_app_adr") > -1 || u.search("xy_app_adr") > -1) {
        device = "androidApp";
        appType = "xy";
      } else if (u.indexOf("51jobapp") > -1 || u.search("51jobapp") > -1) {
        device = "androidApp";
        appType = "job";
      } else if (
        u.indexOf("yjsandroid-android-client") > -1 ||
        u.search("yjsandroid-android-client") > -1
      ) {
        device = "androidApp";
        appType = "yjs";
      } else if (u.toLowerCase().indexOf("micromessenger") > -1) {
        device = "android";
        appType = "weixin";
      } else {
        device = "android";
        appType = "";
      }
    } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      // 判断是APP还是浏览器
      if (u.indexOf("xy_app_iphone") > -1 || u.search("xy_app_iphone") > -1) {
        device = "iosApp";
        appType = "xy";
      } else if (u.indexOf("51jobapp") > -1 || u.search("51jobapp") > -1) {
        device = "iosApp";
        appType = "job";
      } else if (
        u.indexOf("yjsiphone-iphone-client") > -1 ||
        u.search("yjsiphone-iphone-client") > -1
      ) {
        device = "iosApp";
        appType = "yjs";
      } else if (u.toLowerCase().indexOf("micromessenger") > -1) {
        device = "ios";
        appType = "weixin";
      } else {
        device = "ios";
        appType = "";
      }
    } else if (u.indexOf("ArkWeb") > -1 || u.toLowerCase().indexOf("openharmony") > -1) {
      // 判断是APP还是浏览器
      if (u.indexOf("xy_app_harmony") > -1 || u.search("xy_app_harmony") > -1) {
        device = "harmonyApp";
        appType = "xy";
      } else if (u.indexOf("51jobapp") > -1 || u.search("51jobapp") > -1) {
        device = "harmonyApp";
        appType = "job";
      } else if (
        u.indexOf("yjsharmony-harmony-client") > -1 ||
        u.search("yjsharmony-harmony-client") > -1
      ) {
        device = "harmonyApp";
        appType = "yjs";
      } else if (u.toLowerCase().indexOf("micromessenger") > -1) {
        device = "harmony";
        appType = "weixin";
      } else {
        device = "harmony";
        appType = "";
      }
    }
  } else {
    device = "pc";
  }

  // 设置platform
  if ((device == "androidApp" || device == "iosApp" || device == "harmonyApp") && appType == "job") {
    platform = "51jobApp";
  } else if (device == "wechat" && from == "51job") {
    platform = "51jobWX";
  } else if ((device == "android" || device == "ios" || device == "harmony") && from == "51job") {
    platform = "51jobM";
  } else if (device == "pc" && from == "51job") {
    platform = "51jobPC";
  } else if ((device == "androidApp" || device == "iosApp" || device == "harmonyApp") && appType == "yjs") {
    platform = "yjsApp";
  } else if (device == "wechat" && from == "yjs") {
    platform = "yjsWX";
  } else if ((device == "android" || device == "ios" || device == "harmony") && from == "yjs") {
    platform = "yjsM";
  } else if (device == "pc" && from == "yjs") {
    platform = "yjsPC";
  }

  // 设置fromdomain
  if (["51jobApp"].includes(platform)) {
    fromdomain =
      device == "androidApp"
        ? "51job_app_adr"
        : device == "iosApp"
        ? "51job_app_iphone"
        : device == "harmonyApp"
        ? "51job_app_harmony"
        : "51job_m";
  } else if (["51jobM"].includes(platform)) {
    fromdomain = "51job_m";
  } else if (["51jobPC"].includes(platform)) {
    fromdomain = "51job_web";
  } else if (["51jobWX"].includes(platform)) {
    fromdomain = "51job_weixin_wxapp";
  } else if (["yjsApp"].includes(platform)) {
    fromdomain =
      device == "androidApp"
        ? "yjs_adr"
        : device == "iosApp"
        ? "yjs_iphone"
        : device == "harmonyApp"
        ? "yjs_harmony"
        : "yjs_h5";
  } else if (["yjsM"].includes(platform)) {
    fromdomain = "yjs_h5";
  } else if (["yjsPC"].includes(platform)) {
    fromdomain = "yjs_web";
  } else if (["yjsWX"].includes(platform)) {
    fromdomain = "yjs_wxapp";
  } else {
    fromdomain = "";
  }
  store.commit("setValue", {
    device: device,
    appType: appType,
    platform: platform,
    fromdomain: fromdomain,
  });
  return store.state.commonStore.device;
};

// 根据环境 跳转相应地址
const jumpWithEnv = (urlObj, way = "self") => {
  let env = store.state.commonStore.platform;

  if (store.state.commonStore.device == "harmonyApp") {
    window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
      url: urlObj[env]
    }));
  } else if (env && urlObj[env]) {
    // 小程序跳转单独处理
    if (env == "51jobWX" || env == "yjsWX") {
      wx.miniProgram.navigateTo({
        url: urlObj[env],
      });
    } else if (way === "self") {
      window.location.href = urlObj[env];
    } else {
      window.open(urlObj[env]);
    }
  }
};

// 根据环境 跳转职位详情
const toJobDetail = (item, index, length, way = "self") => {
  const property = getJobShortExposureParams(item, index, length);
  const pageCode = JSON.parse(property).pageCode;
  const requestId = JSON.parse(item.property).requestId
  jumpWithEnv(
    {
      "51jobApp": `qiancheng://home/show_job_info?jobid=${
        item.jobId
      }&from=${pageCode}&property=${encodeURIComponent(property)}`,
      "51jobM": `https://msearch.51job.com/jobs/${item.hrefAreaPinYin}/${
        item.jobId
      }.html?rc=${pageCode}&jobtype=${item.jobType}${
        requestId ? "&req=" + requestId : ""
      }`,
      "51jobPC": `https://jobs.51job.com/${item.hrefAreaPinYin}/${
        item.jobId
      }.html?s=${pageCode}&t=${item.jobType}${
        requestId ? "&req=" + requestId : ""
      }`,
      "51jobWX": `/pages/jobs/jobdetail/jobdetail?jobid=${
        item.jobId
      }&parentPagecode=${item.pageCode}&property=${encodeURIComponent(
        property
      )}`,
      yjsApp: `yingjiesheng://home/openJobDetailPage?jobId=${
        item.jobId
      }&property=${encodeURIComponent(property)}`,
      yjsM: `https://m.yingjiesheng.com/jobdetail/${item.jobId}?property=${property}`,
      yjsPC: `https://q.yingjiesheng.com/pc/jobdetail?jobid=${item.jobId}&property=${property}`,
      yjsWX: `/pages/JM/jobdetail/index?jobid=${
        item.jobId
      }&property=${encodeURIComponent(property)}`,
    },
    way
  );
};

// 根据环境 跳转公司详情
const toCompanyDetail = (item, index, source) => {
  const pageCode = item.property ? JSON.parse(item.property).pageCode : "";
  const requestId = JSON.parse(item.property).requestId
  // source:true,app秋招跳转公司详情热门tab
  jumpWithEnv({
    "51jobApp": source
      ? `qiancheng://home/show_co_all_jobs?coid=${item.coId}&pagecode=${pageCode}&property=${item.property}`
      : `qiancheng://home/show_co_info?coid=${item.coId}&pagecode=${pageCode}&property=${item.property}`,
    "51jobM": `https://msearch.51job.com/jobs/all/co${item.coId}.html?rc=${pageCode}${
      requestId ? "&req=" + requestId : ""
    }`,
    "51jobPC": `https://jobs.51job.com/all/co${item.coId}.html?s=${pageCode}${
      requestId ? "&req=" + requestId : ""
    }`,
    "51jobWX": `/pages/jobs/codetail/codetail?coid=${
      item.coId
    }&companyRank=${index}&flagNav=${
      source ? "1" : "2"
    }&property=${encodeURIComponent(item.property)}`,
    yjsApp: `yingjiesheng://home/openCompanyDetailPage?companyId=${
      item.coId
    }&pageCode=${pageCode}&defaultTab=${source ? "2" : "1"}`,
    yjsM: `https://q.yingjiesheng.com/download`,
    yjsPC: `https://q.yingjiesheng.com/download`,
    yjsWX: `/pages/JM/companydetail/index?coid=${
      item.coId
    }&property=${encodeURIComponent(item.property)}`,
  });
};

// 根据环境 跳转置顶公司详情
const toTopCompanyDetail = (item, index, source) => {
  const pageCode = item.property ? JSON.parse(item.property).pageCode : "";
  // source:true,app秋招跳转公司详情热门tab
  jumpWithEnv({
    "51jobApp": `qiancheng://home/show_webpage?url=${encodeURIComponent(
      item.jumpLink
    )}`,
    "51jobM": `${item.jumpLink}`,
    "51jobPC": `${item.jumpLink}`,
    "51jobWX": `/pages/jobs/codetail/codetail?coid=${
      item.coId
    }&companyRank=${index}&flagNav=${
      source ? "1" : "2"
    }&property=${encodeURIComponent(item.property)}`,
    yjsApp: `yingjiesheng://home/openCompanyDetailPage?companyId=${
      item.coId
    }&pageCode=${pageCode}&defaultTab=${source ? "2" : "1"}`,
    yjsM: `https://q.yingjiesheng.com/download`,
    yjsPC: `https://q.yingjiesheng.com/download`,
    yjsWX: `/pages/JM/companydetail/index?coid=${
      item.coId
    }&property=${encodeURIComponent(item.property)}`,
  });
};

//埋点公共属性
const getProperty = () => {
  let param = {
    partner: store.state.commonStore.partner,
    webId: store.getters.webId,
    fromdomain: store.getters.fromdomain,
    frompageUrl: store.state.commonStore.frompageUrl
      ? store.state.commonStore.frompageUrl.split("?")[0]
      : "",
    pageUrl: location.href.split("?")[0],
    isLogin: store.state.commonStore.accountId ? "是" : "否",
    accountId: store.state.commonStore.accountId,
  };
  return param;
};

// 获取职位曝光埋点参数（双列职位）
const getJobShortExposureParams = (item, index, length, extraParams) => {
  const property = item.property ? JSON.parse(item.property) : "";
  let funcType = item.funcTypeCode || "";
  if (!funcType) {
    if (item.funcType1Code) {
      funcType += item.funcType1Code;
    }
    if (item.funcType2Code) {
      funcType += funcType ? "," + item.funcType2Code : item.funcType2Code;
    }
  }
  
  const params = {
    pageCode: item.pageCode || property.pageCode,
    shortPageCode: item.shortPageCode || property.shortPageCode,
    isSuggest: property.isSuggest,
    policyId: property.policyId,
    requestId: property.requestId,
    searchType: property.searchType,
    jobRank: index,
    jobSource: item.jobSource,
    jobId: item.jobId,
    jobTitle: item.jobName,
    jobType: item.jobType || property.jobType || "0",
    funcType,
    jobSalary: item.provideSalaryString,
    jobArea: item.jobAreaString,
    jobYear: item.workYearString,
    jobDegree: item.degreeString,
    jobTime: item.issueDateString,
    monthSalary: item.provideSalaryString,
    companyId: item.coId || item.companyId,
    companyName: item.companyName,
    isPromote: item.isPromotion ? "是" : "否",
    awardsLabel: item.isModelEmployer ? "优选雇主" : "无",
    pageNum: property.pageNum,
    contentRank: index,
    resultNumber: length,
    jobLabel: getJobLabel(item),
    advId: item.adId || item.advId,
    bcopExrinfo: {
      pageCode: item.pageCode || property.pageCode,
      ...JSON.parse(extraParams?.exrInfo || "{}"),
      isWelfareShow:
        item.customWelfareList && item.customWelfareList.join(",")
          ? "是"
          : "否",
      welfareList: item.customWelfareList
        ? item.customWelfareList.join(",")
        : "",
    },
    exrInfo02: item.exrInfo02,
    // ...extraParams, // 额外参数 例如{ exrInfo: JSON.stringify({ isFullJobCard: false, cityType: '机会城市' }), naviName1: '' }
  };

  if (extraParams && ('subContentRank' in extraParams)) {
    params.bcopExrinfo.subContentRank = extraParams.subContentRank;
  }

  params.bcopExrinfo = JSON.stringify(params.bcopExrinfo);

  return JSON.stringify(params);
};

// 获取职位曝光埋点参数（单列、公司列表）
const getJobShortExposureData = (item, index, extraParams) => {
  const property = item.property ? JSON.parse(item.property) : "";
  let funcType = item.funcTypeCode || "";
  if (!funcType) {
    if (item.funcType1Code) {
      funcType += item.funcType1Code;
    }
    if (item.funcType2Code) {
      funcType += funcType ? "," + item.funcType2Code : item.funcType2Code;
    }
  }
  return JSON.stringify({
    pageCode: item.pageCode || property.pageCode,
    shortPageCode: item.shortPageCode || property.shortPageCode,
    requestId: property.requestId || "",
    searchType: "自动搜索职位",
    moduleName: "",
    jobRank: index,
    jobSource: item.jobSource,
    jobId: item.jobId,
    jobTitle: item.jobName,
    jobType: item.jobType || property.jobType || "0",
    funcType,
    jobSalary: item.provideSalaryString,
    jobArea: item.jobAreaString,
    jobYear: item.workYearString,
    jobDegree: item.degreeString,
    jobTime: item.issueDateString,
    companyId: item.coId || item.companyId,
    isPromote: item.isPromotion ? "是" : "否",
    awardsLabel: item.isModelEmployer ? "优选雇主" : "无",
    pageNum: property.pageNum || 1,
    jobLabel: getJobLabel(item),
    exrInfo: item.exrInfo02,
    // ...extraParams, // 额外参数 例如{ exrInfo: JSON.stringify({ isFullJobCard: false, cityType: '机会城市' }), naviName1: '' }
    bcopExrinfo: JSON.stringify({
      pageCode: item.pageCode || property.pageCode,
      ...JSON.parse(extraParams?.exrInfo || "{}"),
      isWelfareShow:
        item.customWelfareList && item.customWelfareList.join(",")
          ? "是"
          : "否",
      welfareList: item.customWelfareList
        ? item.customWelfareList.join(",")
        : "",
    }),
  });
};

// 获取公司曝光埋点参数
const getCompanyShortExposureData = (item, index, showThread) => {
  const property = item.property ? JSON.parse(item.property) : "";
  const ehrData = {
    isQAShow:
      showThread === 1 && item.isSomeXyz && item.questionList ? "是" : "否",
    isPostShow: item.questionList?.length > 0 ? "是" : "否",
    contentId: item.questionList
      ? item.questionList.map((item) => item.id).join("_")
      : "",
  };
  return JSON.stringify({
    pageCode: item.pageCode || property.pageCode,
    shortPageCode: item.shortPageCode || property.shortPageCode,
    requestId: property.requestId || "",
    searchType: "自动搜索公司",
    companyRank: index,
    companyId: item.coId,
    companyName: item.companyName,
    companyProperty: item.companyTypeString,
    companyType: item.companyTypeString,
    companySize: item.companySizeString,
    industry: item.industryType1Str || item.industryType2Str,
    // exrInfo: JSON.stringify(ehrData),
    bcopExrinfo: JSON.stringify({
      pageCode: item.pageCode || property.pageCode,
      ...ehrData,
    }),
  });
};

// 获取职位标签
const getJobLabel = (job) => {
  let jobLabelArr = [];
  if (job.isTop) {
    jobLabelArr.push("热门");
  }
  if (job.isUrgency) {
    jobLabelArr.push("急聘");
  }
  if (job.isIntern) {
    jobLabelArr.push("实习");
  }
  if (job.isQuickFeedback) {
    jobLabelArr.push("反馈快");
  }
  if (job.isNew) {
    jobLabelArr.push("new");
  }
  return jobLabelArr.join(",");
};

// 神策初始化、以及login
const sensorsInit = (accountid = "", uuid = "") => {
  //更新唯一标识
  if (accountid) store.commit("setValueLocalStorage", { accountid: accountid });
  if (uuid) store.commit("setValueLocalStorage", { uuid: uuid });
  if (accountid || uuid) {
    sensors.login(
      store.state.commonStore.accountid || store.state.commonStore.uuid
    );
  }
  //首次触发页面加载事件 $pageview
  if (store.state.commonStore.isSensorsInit != 1) {
    store.commit("setValue", {
      isSensorsInit: 1,
    });
    sensors.quick("autoTrack");
  }
};

// 获取app版本号
const getAppVersion = () => {
  const ua = navigator.userAgent;
  return ua.slice(ua.lastIndexOf("/") + 1) || "0.0.0";
};

//获取安卓版本号
const getAndroidVersion = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (!(ua.indexOf("android") > -1 || ua.indexOf("adr") > -1)) return false;
  const match = ua.match(/android\s([0-9.]*)/);
  return match ? match[1] : false;
};

// 处理通用登录逻辑
const toLogin = (partner) => {
  const currentUrl = window.location.href;
  const platform = store.getters.platform;
  const keys = Object.keys(loginUrl);
  if (keys.includes(platform)) {
    let targetUrl = `${loginUrl[platform]}${encodeURIComponent(currentUrl)}`;
    if (partner) {
      targetUrl = `${targetUrl}&partner=${partner}`;
    }
    window.location.href = targetUrl;
  }
};
// 清空登录信息
const clearlocalStorage = () => {
  localStorage.removeItem("isGetUserToken");
  localStorage.removeItem("logintime");
  localStorage.removeItem("xy_jwt");
  localStorage.removeItem("accountId");
  localStorage.removeItem("uuid");
  localStorage.removeItem("xy_usertoken");
  localStorage.removeItem("token");
  localStorage.removeItem("accountid");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("partner");
  localStorage.removeItem("partnerH5");
  localStorage.removeItem("userType");
  localStorage.removeItem("okUserInfo");
  localStorage.removeItem("welcomeModalShow");
};

//判断是不是在app
const isApp = (device) => {
  return device == "IOS" || device == "Android" || device == "Harmony";
};

// 去聊聊
const goChatNew = async (item, storeData, itemSensors) => {
  console.log("去聊聊", item, storeData);
  // let projectType = storeData.projectType;
  let jobid, hruid, ctmid;
  // if (projectType == "job") {
  //   jobid = item?.detailJobInfo.jobId;
  //   hruid = item?.jobHrInfo.hrUid;
  //   ctmid = item?.jobHrInfo.ctmId;
  // } else {
  //   jobid = item.jobid;
  //   hruid = item.hruid;
  //   ctmid = item.ctmid;
  // }
  jobid = item.jobId;
  hruid = item.hrUid;
  ctmid = item.ctmId;
  const platform = store.getters.platform;
  if (hruid) {
    sensors.track("$WebClick", {
      $element_id: "sensor_home_jobcardll",
      contentType: "去聊聊",
      contentName: "minidetail",
    });
    const isNotApp = platform != "51jobApp" && platform != "yjsApp";
    if (isNotApp && platform.indexOf("job") > -1) {
      Toast("请在51jobApp中操作");
      return;
    } else if (isNotApp && platform.indexOf("yjs") > -1) {
      Toast("请在应届生App中操作");
      return;
    }
    const resumeid = store.getters["resumeStore/resumeId"] || "";
    if (platform == "51jobApp") {
      const version = Number(getAppVersion().split(".").join(""));
      let url = "";
      if (version > 1390) {
        url = `qiancheng://home/show_imsession_page?jobid=${jobid}&hruid=${hruid}&ctmid=${ctmid}&resumeid=${resumeid}&pagecode=${itemSensors.pageCode}`;
      } else {
        url = `qiancheng://home/show_imsession_page?jobid=${jobid}&hruid=${hruid}&ctmid=${ctmid}&pagecode=${itemSensors.pageCode}`;
      }

      if (store.state.commonStore.device == "harmonyApp") {
        window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
          url: url
        }));
      } else {
        window.location.href = url;
      }
    } else {
      window.location.href = `yingjiesheng://home/openJoberChatPage?jobId=${jobid}&hrUid=${hruid}&ctmId=${ctmid}&resumeId=${resumeid}&pagecode=${itemSensors.pageCode}`;
    }
  } else {
    Toast({
      duration: 2000,
      message: "该职位暂不支持聊天",
    });
  }
};

// 检查是否登录
const checkLoginStatus = (flag) => {
  //   flag true | false
  //   true: 未登录时候，跳转登录页面
  //   false: 未登录时候返回false，登录时候返回true
  const accountId = store.state.commonStore.accountId;
  if (flag) {
    if (accountId) {
      return true;
    } else {
      toLogin();
      return false;
    }
  } else {
    return !!accountId;
  }
};

// 向微信发送通知
const wxSharePost = (shareData = {}) => {
  wx.miniProgram.postMessage({
    data: {
      ...shareData,
    },
  });
};

// 页面分享初始化
const pageShareInit = (shareParams = {}) => {
  let device = store.state.commonStore.device;
  console.log(store.state.commonStore.device, "store.state.commonStore.device");
  console.log(
    store.state.commonStore.appType,
    "store.state.commonStore.appType"
  );
  if (device == "androidApp" || device == "iosApp") {
    const params = {
      share_img: shareParams.shareImg || "",
      sharetitle: shareParams.shareTitle || "",
      sharetxt: shareParams.shareText || "",
      post_image: shareParams.postImage || "", //海报分享的图片 base64
      post_url_image: shareParams.postUrlImage || "",
      share_url: shareParams.shareUrl || window.location.href,
      shareId: shareParams.shareId || "",
    };
    store.commit("setValue", {
      isHasHaiBao: shareParams.isHasHaiBao || "0",
      shareParam: params,
    });
  } else if (device != "pc" && store.state.commonStore.appType == "weixin") {
    getWechatConfig(shareParams);
  }
};

// 页面分享配置(微信环境)
const wechatConfig = async (shareParams = {}, res) => {
  console.log(shareParams, "shareParams");
  console.log(res, "wechatConfig");
  if (res) {
    wx.config({
      debug: false,
      appId: res.appID || res.appId,
      timestamp: res.timestamp,
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
    });
    wx.ready(() => {
      let options = {
        title: shareParams.shareTitle,
        desc: shareParams.shareText,
        link: shareParams.shareUrl || window.location.href,
        imgUrl: shareParams.shareImg,
        debug: false,
        success: function () {
          console.log("分享成功");
          const url = window.location.href;
          if (url.indexOf("/beginning") > -1 || url.indexOf("/my") > -1) {
            sensors.track("WidgetShow", {
              $element_id: shareParams.shareId,
            });
          }
          // store.state.commonStore.accountId && addShakeLottery('share');
        },
        fail: function (error) {
          console.log("分享失败", error);
          // store.state.commonStore.accountId && addShakeLottery('share');
        },
      };
      wx.updateAppMessageShareData(options); // 微信好友
      wx.updateTimelineShareData(options); // 微信朋友圈
    });
    wx.error((error) => {
      console.log("config:", error);
    });
  }
};

// 获取微信配置
const getWechatConfig = async (shareParams) => {
  const platform = store.state.commonStore.platform;
  // if (platform == 'yjsM') {
  //   const res = await context.$api.user.getYjsWxConfig({
  //     url: window.location.href,
  //     app: 'yjs_wx_mp',
  //   });
  //   console.log('yjsRes', res);
  //   if (res.status == 1) return res.resultbody;
  //   else return false;
  // }
  if (platform == "51jobM") {
    let url = `https://m.51job.com/wx/getjssdk.php?calcData=calcData&url=${encodeURIComponent(
      window.location.href
    )}`;
    await Jsonp(
      url,
      {
        param: "jsoncallback",
      },
      (err, res) => {
        if (err) {
          console.log(err);
        }
        if (res) {
          console.log("51jobres", res);
          wechatConfig(shareParams, res);
        }
      }
    );
  }
};
function watchAppCover(callback = "", callleave = "") {
  function vFun() {
    if (document.hidden) {
      if (typeof callleave === "function") {
        callleave();
      }
    } else if (typeof callback === "function") {
      callback();
      window.removeEventListener("visibilitychange", vFun, true);
    }
  }
  window.addEventListener("visibilitychange", vFun, true);
}
// 获取求职意向
const getIntention = async () => {
  console.log("获取求职意向getIntention");
  const platform = store.getters.platform;
  let intention = null;
  //51job求职意向列表
  if (platform.includes("51job")) {
    const res = await user.get51JobIntentions({
      isEnglish: false,
    });
    if (res && res.status == 1) {
      const items = res.resultbody.items || [];
      if (items.length > 0) {
        const obj = res.resultbody.items[0];
        intention = {
          expectArea: obj.expectArea || "",
          expectAreaString: obj.expectAreaString || "",
          expectFunction: obj.expectFunction || "",
          expectFunctionString: obj.expectFunctionString || "",
          expectIndustry: obj.expectIndustry || "",
          expectIndustryNew: obj.expectIndustry || "",
          minSalary: obj.minSalary, // 期望薪资下限
          maxSalary: obj.maxSalary, // 期望薪资上限
          seekType: obj.seekType,
        };
      }
    }
  } else {
    const res = await user.getYJSIntentions({
      isEnglish: false,
    });
    if (res && res.status == 1) {
      const expectFuncs = res.resultbody.expectFunc.items || [];
      if (expectFuncs.length > 0) {
        const expectArea_obj = res.resultbody.expectArea.items[0];
        const expectFunc_obj = res.resultbody.expectFunc.items[0];
        const seekType = res.resultbody.jobTerm?.code;
        intention = {
          expectArea: expectArea_obj.expectArea || "",
          expectAreaString: expectArea_obj.expectAreaString || "",
          expectFunction: expectFunc_obj.expectFunc || "",
          expectFunctionString: expectFunc_obj.expectFuncString || "",
          expectIndustry: "",
          expectIndustryNew: "",
          minSalary: 0, // 期望薪资下限
          maxSalary: 0, // 期望薪资上限
          seekType: seekType || "",
        };
      }
    }
    console.log(intention, "11111111111111111");
  }
  if (intention) {
    // this.intention = intention;
    store.commit("setIntention", intention);
    return true;
  } else {
    return false;
  }
};
const toNum = (a) => {
  const b = a.toString();
  // 也可以这样写 var c=a.split(/\./);
  const c = b.split(".");
  const num_place = ["", "0", "00", "000", "0000"];
  const r = num_place.reverse();
  for (let i = 0; i < c.length; i++) {
    const len = c[i].length;
    c[i] = r[len] + c[i];
  }
  const res = c.join("");
  return res;
};
const cpr_version = (a, b) => {
  const _a = toNum(a);
  const _b = toNum(b);
  if (_a == _b) return true;
  if (_a > _b) return true;
  if (_a < _b) return false;
};
// 打开消息与系统设置页
const openMessageAndSystemSettingPage = () => {
  const appVersion = navigator.userAgent.slice(
    navigator.userAgent.lastIndexOf("/") + 1
  );
  if (cpr_version(appVersion, "9.5.0")) {
    window.location.href =
      "yingjiesheng://home/openMessageAndSystemSettingPage";
  } else {
    Toast({
      duration: 2000,
      message: "请升级至最新版本体验哦~",
    });
  }
};
// 缓存首屏需去重组件的职位jobids
const setFilterJobIds = (currentDeWeightSort,jobInfoList,hasChild)=>{
  console.log("触发缓存jobid",currentDeWeightSort);
  if(hasChild){//组件里有多个接口请求，也须依次加载
    let arrSort = currentDeWeightSort.split("-");
    let childNum = Number(arrSort[1]);
    childNum ++;
    let newSort = arrSort[0]+'-'+childNum;
    store.commit("setValue", {
      deweightComponentSort: newSort,
    });
  }else{
    store.commit("setValue", {
      deweightComponentSort: (Number(currentDeWeightSort)+ 1),
    });
  }
  if(jobInfoList && jobInfoList.length > 0){
    let filterJobIds = [];
    jobInfoList.map(item => {
      if(item.jobId){
        filterJobIds.push(item.jobId.toString());
      }else{
        if(item.jobInfo && item.jobInfo.length > 0){//公司列表
          item.jobInfo.map(k => {
            if(k.jobId){
              filterJobIds.push(k.jobId.toString());
            }
          });
        }   
      }
    });
    console.log("触发",filterJobIds)
    if(sessionStorage.getItem("filterJobIds")){//存有id值，合并重新赋值
      let newJobIds = filterJobIds.concat(JSON.parse(sessionStorage.getItem("filterJobIds")));
      filterJobIds = [...new Set(newJobIds)];
    }
    // filterJobIds.push(currentDeWeightSort);
    sessionStorage.setItem("filterJobIds",JSON.stringify(filterJobIds));//存在缓存里
  }
}
// 获取链接参数
const getHrefParams = (name) => {
  let ItemArr = [];
  let ItemObj = {};
  window.location.href
    .substring(window.location.href.lastIndexOf('?') + 1, window.location.href.length)
    .split('&')
    .map((item) => {
      ItemArr.push(item.split('='));
    });
  ItemArr.map((item) => {
    ItemObj[item[0]] = item[1];
  });
  return ItemObj[name];
};

const shouldNativeBackGesture = ()=> {
  window.shouldNativeBackGesture = () => {
    const url = location.href.split("?")[0].split('/').pop()
    let appswiper = localStorage.getItem(`${url}_appswiper`)
    return appswiper ? false : true
  }
}

export default {
  getuuid,
  goBack,
  getToday,
  goHome,
  getAppStateHeight,
  initDevice,
  jumpWithEnv,
  toJobDetail,
  toCompanyDetail,
  getProperty,
  getJobShortExposureParams,
  getJobLabel,
  sensorsInit,
  getAppVersion,
  getAndroidVersion,
  toLogin,
  clearlocalStorage,
  isApp,
  goChatNew,
  checkLoginStatus,
  getJobShortExposureData,
  getCompanyShortExposureData,
  wxSharePost,
  pageShareInit,
  wechatConfig,
  getWechatConfig,
  toTopCompanyDetail,
  watchAppCover,
  getIntention,
  openMessageAndSystemSettingPage,
  adrBackNotice,
  setFilterJobIds,
  getHrefParams,
  shouldNativeBackGesture
};
